export const SEARCH_QUERY_MIN_LENGTH = 3

export const PUBLIC_SALE_PRIOR_TO_START_SECONDS = 120

export const DRAWER_MAX_WIDTH_REM = 25

export const AddressZero = '0x0000000000000000000000000000000000000000'

export const PAGE_HELMET_DESCRIPTION =
  'Dive into Joepegs, the leading Web3 platform for NFTs and digital collectibles. As a cultural hub in the Web3 space, we offer secure buying, selling, and discovery of innovative digital assets.'

export const PAGE_HELMET_COLLECTION_DESCRIPTION =
  'Explore the hall of fame of Avalanche NFT collections on Joepegs, from Chikn and Smol Joes to the 2021 originals, with every item, trait and transfer.'

export const PAGE_HELMET_MINT_DESCRIPTION =
  "Get your hands on brand new NFTs and digital collectibles with Joepegs' launchpad. Join exciting mint events and step into the cultural pulse of the Web3 space. Trade and discover unique digital assets with ease."
